import { countryRoutes } from './countries';
import { currencyRoutes } from './currencies';

export const generalRoutes = [
  {
    path: 'general',
    children: [...countryRoutes, ...currencyRoutes],
  },
];
